import api from "@/api";
import { useAppStore } from "@/stores/app";

interface FeedSyncRequest {
  isBrand: boolean;
  sheetUrl: string;
  name?: string;
}

class FeedService {
  private base = (): string => {
    const appStore = useAppStore();
    return `businessProfiles/${appStore.selectedBusinessProfileId}/roimatic/feedEnhancements`;
  };

  lookupFile = async (tableName: "Brands" | "Products"): Promise<any> => {
    try {
      return await api.get(`${this.base()}/files/lookup`, { tableName });
    } catch (error: any) {
      if (error?.response?.status === 204) {
        return null;
      }
      throw error;
    }
  };

  getFile = (id: number): Promise<any> => api.get(`${this.base()}/files/${id}`);

  sync = (body: FeedSyncRequest): Promise<any> => api.post(`${this.base()}/files/sync`, body);

  getLatestResult = async (id: number): Promise<any> => {
    try {
      return await api.get(`${this.base()}/files/${id}/requestLogs/latest`);
    } catch (error: any) {
      if (error?.response?.status === 204) {
        return null;
      }
      throw error;
    }
  };
}

export default FeedService;
